import { render } from "./SettingSection.vue?vue&type=template&id=765ae177&scoped=true"
import script from "./SettingSection.vue?vue&type=script&lang=js"
export * from "./SettingSection.vue?vue&type=script&lang=js"

import "./SettingSection.vue?vue&type=style&index=0&id=765ae177&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765ae177"]])

export default __exports__